<div class = "reusable-form-component align-center" (click) = "onClick()">
  <i class = "{{icon}}"></i>
  <!-- <span class = "orange mont-bold small-font text-italic">{{ labelText }}</span> -->
  <span class = "add-label">{{ labelText }}</span>
</div>